<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/result-liveness.svg" alt="graphic-404" class="mx-auto mb-4 custom-w-full">
            <h1 class="sm:mx-0 mx-4 mb-4 text-5xl d-theme-heading-color">Verificación biométrica realizada. Será redirigido al trámite.</h1>
            <!-- <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse" style="color: #5a5454;">Puede regresar a la vista del firmador.</p> -->
        </div>
    </div>
</template>

<script>
export default {
      data () {
          return {
          }
      },

      methods:{
      },
      mounted () {
        setTimeout(function() {
            window.close()
        }, 3000);
      }
}
</script>

<style>
    .custom-w-full {
        max-width: 30% !important;
    }
</style>
